module.exports = __webpack_public_path__ + "media/images/icons/flags/IS-20fbe76d4ae5b6a92c4621dbaec78b8f.svg";